import {
    RichTableColumns,
} from 'app/types/richtable.types'
import {
    CollectionServiceType, DeliveryServiceType,
    OpportunityFrequency, LaneStatus,
} from 'app/enums/label.enums'
import SkyNetLink, {
    TypeLink,
    SizeLink,
} from 'app/shared-components/SkyNetLink'
import {
    AccountLanesTable,
} from 'app/Apps/AccountManagement/AccountLanes/AccountLanes.types'
import {
    RequestedLane,
} from '../../AQuotes.types'

const columns = ({
    l,
    laneStyle,
    getLaneLink,
    getOpportunityLink,
}: {
    l: (l: string) => string,
    laneStyle: string,
    getLaneLink: (id: string) => string,
    getOpportunityLink: (id: string) => string,
}): RichTableColumns<keyof (RequestedLane & AccountLanesTable)>[] => {
    return [
        {
            id: 'laneNumber',
            headerProps: {
                children: l('AccountLane.lane'),
            },
            mapCellProps: ({
                laneNumber,
                id,
            }) => {
                return {
                    value: laneNumber,
                    link: getLaneLink(id),
                    type: TypeLink.EXTERNAL,
                    className: laneStyle,
                    size: SizeLink.S,
                }
            },
            Cell: SkyNetLink,
        },
        {
            id: 'opportunity',
            headerProps: {
                children: l('AccountLane.opportunity'),
            },
            mapCellProps: ({
                opportunity,
                opportunityId,
            }) => {
                return {
                    value: opportunity,
                    link: getOpportunityLink(opportunityId),
                    type: TypeLink.EXTERNAL,
                    className: laneStyle,
                    size: SizeLink.S,
                }
            },
            Cell: SkyNetLink,
        },
        {
            id: 'expPalletsYear',
            headerProps: {
                children: 'Expected Pallets / Year',
            },
            mapCellProps: 'expPalletsYear',
        },
        {
            id: 'frequency',
            headerProps: {
                children: 'Frequency',
            },
            mapCellProps: 'frequency',
            componentName: 'EnumValue',
            allowedValuesEnum: OpportunityFrequency,
        },
        {
            id: 'originAirport',
            headerProps: {
                children: l('AccountLaneForm.originAirport'),
            },
            mapCellProps: 'originAirport',
        },
        {
            id: 'destinationAirport',
            headerProps: {
                children: l('AccountLaneForm.destinationAirport'),
            },
            mapCellProps: 'destinationAirport',
        },
        {
            id: 'deliveryServiceType',
            headerProps: {
                children: l('AccountLane.deliveryServiceType'),
            },
            mapCellProps: 'deliveryServiceType',
            componentName: 'EnumValue',
            allowedValuesEnum: DeliveryServiceType,
        },
        {
            id: 'collectionServiceType',
            headerProps: {
                children: l('AccountLane.collectionServiceType'),
            },
            mapCellProps: 'collectionServiceType',
            componentName: 'EnumValue',
            allowedValuesEnum: CollectionServiceType,
        },
        {
            id: 'productTypes',
            componentName: 'List',
            headerProps: {
                children: l('AccountQuotes.productTypes'),
            },
            mapCellProps: 'productTypes',
        },
        {
            id: 'baseLeaseDays',
            headerProps: {
                children: l('AccountQuotes.laneBaseLeaseDays'),
            },
            mapCellProps: ({
                baseLeaseDays,
            }) => {
                return {
                    children: baseLeaseDays.join(', '),
                }
            },
        },
        {
            id: 'laneStatus',
            headerProps: {
                children: l('AccountLane.laneStatus'),
            },
            mapCellProps: 'laneStatus',
            componentName: 'EnumValue',
            allowedValuesEnum: LaneStatus,
        },
        {
            id: 'otherComments',
            headerProps: {
                children: l('AccountQuotes.quoteLaneComment'),
            },
            mapCellProps: 'otherComments',
        },
    ]
}

export default columns
